import { Power1, TweenLite } from "gsap";
import 'intersection-observer';
import * as React from "react";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { decodeHTMLEntities } from "../../../../../helpers";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";

export type BarometerBlockprops<extra_images> = {
  blockName: 'vidda/barometer'
  index: number
  title: string
  text: string
  graphs: Array<GraphProps>
}

export type BarometerBlockStyle = Partial<{
}>

export function BarometerBlock<customBlockData, extra_images>(
  props: BarometerBlockprops<extra_images>,
  options?: { style?: BarometerBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => {
        return (
          <section
          className={`block block--barometer`}
          key={options && options.key ? options.key : 'barometer-block'}
        >
          <div className="block__inner">
          { (props.title || props.text) && (
              <header className="block__header">
                {props.title && 
                  <h2 className="block__title typo--3xl">{decodeHTMLEntities(props.title)}</h2>
                }
                {props.text && 
                  <div className="block__intro typo--xs" dangerouslySetInnerHTML={{__html: props.text}} /> 
                }
              </header>
            )}
    
            <div className="block__content">
              { props.graphs.map(graph => 
                <Barometer 
                  current={graph.current} 
                  target={graph.target} 
                  min={graph.min} 
                  max={graph.max} 
                  label={graph.label} 
                  target_label={graph.target_label} 
                />
              )}
              
            </div>
          </div>
          </section>
        );
      }
    })
}

export type GraphProps = {
  label: string
  target_label: string
  current: number
  target: number
  min: number
  max: number
}

class Barometer extends React.Component<GraphProps> {

  progress: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();
  progressBar: React.RefObject<SVGPathElement> = React.createRef<SVGPathElement>();
  myTween;

  constructor(props){
    super(props);
    this.myTween = null;
  }

  componentDidMount(){
    let self = this;
    // use the node ref to create the animation
    this.myTween = TweenLite.fromTo(
      this.progressBar.current, 
      this.props.current * 0.0135, 
      {css: {'strokeDashoffset': 844}}, 
      {css: { 'strokeDashoffset': 844 - (844 * (this.props.current / this.props.max)) },
      ease: Power1.easeInOut,
      onUpdate: function () {
        var currentValue = Math.round(this.progress() * self.props.current);
        self.progress.current.innerHTML = currentValue.toString();
      },
      onComplete: () => {
        this.progress.current.innerHTML = this.props.current.toString();
      }
    });
  }

  render(){
    let props = this.props;
    return <div className="barometer">
      <figure className="barometer__visual">

        <div className="barometer__svg-wrapper">
          <svg className="barometer__svg"  width="420px" height="420px" viewBox="0 0 440 440" version="1.1">
            <circle id="" strokeWidth="3" stroke="#f1f1f1" cx="210" cy="208" r="164.5" fill="none"></circle>
            <path id=""
              d="M40.3,314C21.7,283.7,11,248.1,11,210c0-109.9,89.1-199,199-199s199,89.1,199,199 c0,38.1-10.7,73.7-29.3,104"
              stroke="#f1f1f1"
              fill="none"
              strokeWidth="22" 
            />
            
            {props.current >= props.target && 
              <path id=""
                d="M40.3,314C21.7,283.7,11,248.1,11,210c0-109.9,89.1-199,199-199s199,89.1,199,199 c0,38.1-10.7,73.7-29.3,104"
                stroke="#888888"
                fill="none"
                strokeWidth="64"
                strokeDashoffset={ -839 * (props.target / props.max)} 
                strokeDasharray="5,844"
              />
            }

            <path id=""
              d="M40.3,314C21.7,283.7,11,248.1,11,210c0-109.9,89.1-199,199-199s199,89.1,199,199 c0,38.1-10.7,73.7-29.3,104"
              stroke="#d8d8d8"
              fill="none"
              strokeWidth="22"
              strokeDashoffset={844 - (844 * (props.target / props.max))} 
              strokeDasharray="844,844"
            />

            <path className="progress-bar"
              d="M40.3,314C21.7,283.7,11,248.1,11,210c0-109.9,89.1-199,199-199s199,89.1,199,199 c0,38.1-10.7,73.7-29.3,104"
              fill="none"
              stroke="#1a98d8"
              strokeWidth="22"
              strokeDashoffset="844"
              strokeDasharray="844,1688"
              ref={this.progressBar}
            />

            <path id=""
              d="M40.3,314C21.7,283.7,11,248.1,11,210c0-109.9,89.1-199,199-199s199,89.1,199,199 c0,38.1-10.7,73.7-29.3,104"
              stroke="#ffffff"
              fill="none"
              strokeWidth="44"
              strokeDashoffset="5" 
              strokeDasharray="5,51.5"
            />

            {props.current < props.target && 
              <path id=""
                d="M40.3,314C21.7,283.7,11,248.1,11,210c0-109.9,89.1-199,199-199s199,89.1,199,199 c0,38.1-10.7,73.7-29.3,104"
                stroke="#888888"
                fill="none"
                strokeWidth="64"
                strokeDashoffset={-839 * (props.target / props.max)} 
                strokeDasharray="5,844"
              />
            }


          </svg>

          <div className="barometer__progress">
              <strong ref={this.progress}></strong>
              <span>{props.target_label}</span>
            </div>

            <div className="barometer__minmax">
              <span className="barometer__min">{ props.min }</span>
              <span className="barometer__max">{ props.max }</span>
            </div>

        </div>
        {props.label &&
          <figcaption className="barometer__caption">{ props.label }</figcaption>
        }
      </figure>
    </div>
  }
}